import { render, staticRenderFns } from "./qualityHistory.vue?vue&type=template&id=6086069e&"
import script from "./qualityHistory.vue?vue&type=script&lang=js&"
export * from "./qualityHistory.vue?vue&type=script&lang=js&"
import style0 from "./qualityHistory.vue?vue&type=style&index=0&id=6086069e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports